export const userRoleTypes = {
	ADMIN: 'admin',
	USER: 'user'
};
